import React from 'react';

/**
 * AuthContext provides the auth tokens.
 * @typedef {object} AuthContext
 * @property {object} data Auth tokens.
 * @property {Function} setData Update the auth tokens.
 */

/** @type {React.Context<AuthContext>} */
export const AuthContext = React.createContext({
  tokens: {},
  setTokens: () => {},
});

/**
 * ScenarioDiagramContext provides the diagram state.
 * @typedef {object} ScenarioDiagramContext
 * @property {boolean} open Dialog visibility.
 * @property {object} data Dialog data.
 */

/** @type {React.Context<ScenarioDiagramContext>} */
export const ScenarioDiagramContext = React.createContext({
  open: false,
  data: {},
});
